module.exports = __webpack_public_path__ + "static/media/gta.8fed7e9e.ttf";